<template>
  <div class="bg-black overflow-hidden md:pb-16">
    <div class="relative mx-auto">
      <div class="lg:grid lg:grid-cols-2 lg:gap-8">
        <div class="text-center">
          <div class="mx-auto lg:row-start-1 lg:col-start-1 lg:w-84">
            <div>
              <img
                class="mx-auto px-12 h-auto w-full rounded-full md:h-auto md:w-72 lg:w-auto lg:h-64 my-6"
                :src="image"
                :alt="name"
              />
              <div class="space-y-2">
                <div class="text-lg leading-6 blackFont space-y-1">
                  <h4 class="text-white tracking-wider uppercase">
                    {{ name }}
                  </h4>
                  <p class="text-secondary tracking-wide uppercase">
                    {{ title }}
                  </p>
                </div>
                <div class="px-6 pb-8 md:px-12 md:mb-4 space-y-4">
                  <p
                    class="flex justify-center text-white leading-relaxed bookFont"
                  >
                    {{ descOne }}
                  </p>
                  <p
                    class="hidden md:flex justify-center text-white leading-relaxed md:my-8 bookFont text-center"
                  >
                    {{ descTwo }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="flex flex-wrap items-center flex-1"
          :class="[isLeft ? 'md:row-start-1' : '']"
        >
          <div class="relative h-full bg-black w-full">
            <div
              class="h-full flex flex-wrap items-center flex-1 overflow-hidden"
            >
              <img
                v-for="(i, index) in photos"
                :key="index"
                :src="i"
                :class="index == currentIndex ? '' : 'hidden'"
                @click="next"
                v-touch:swipe.left="next"
                v-touch:swipe.right="prev"
                class="slide rounded-lg shadow-lg object-contain w-full h-auto lg:static cursor-pointer"
              />

              <ul class="agile__dots">
                <li
                  class="agile__dot"
                  v-for="(item, index) in photos"
                  :key="index"
                  :class="index == currentIndex ? 'agile__dot--current' : ''"
                >
                  <button type="button" @click="currentIndex = index">
                    {{ index }}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="px-4 pb-8 text-center mt-8 flex md:hidden">
          <p class="text-white leading-relaxed bookFont">{{ descTwo }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Partner",
  components: {},
  props: {
    isLeft: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    image: {
      type: String,
      default: null,
    },
    imageLg: {
      type: String,
      default: null,
    },
    descOne: {
      type: String,
      default: null,
    },
    descTwo: {
      type: String,
      default: null,
    },
    photos: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  mounted: function () {
    //  this.startSlide();
  },

  data() {
    return {
      timer: null,
      currentIndex: 0,
    };
  },
  methods: {
    startSlide: function () {
      this.timer = setInterval(this.next, 3000);
    },

    next() {
      let n = this.currentIndex + 1;
      if (n > this.photos.length - 1) {
        this.currentIndex = 0;
      } else {
        this.currentIndex = n;
      }
    },
    prev() {
      let p = this.currentIndex - 1;
      if (p <= 0) {
        this.currentIndex = this.photos.length - 1;
      } else {
        this.currentIndex -= 1;
      }
    },
  },

  computed: {
    currentImg: function () {
      return this.photos[Math.abs(this.currentIndex) % this.photos.length];
    },
  },
};
</script>


<style>
  .agile__dots {
    bottom: 50%;
    flex-direction: column;
    right: 30px;
    position: absolute;
  }

  .agile__dot {
    margin: 5px 0;
  }

  .agile__dot button {
    background-color: transparent;
    border: 1px solid #fff;
    cursor: pointer;
    display: block;
    height: 10px;
    font-size: 0;
    line-height: 0;
    margin: 0;
    padding: 0;
    transition-duration: 0.3s;
    width: 10px;
  }

  .agile__dot--current button,
  .agile__dot:hover button {
    background-color: #fff;
  }

  .slide {
    display: block;
    height: auto;
    object-fit: cover;
    width: 100%;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
    transition-duration: 2s;
    transition-timing-function: ease-in-out;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    transition: opacity 0.5s;
    transition-duration: 2s;
  }
</style>